import {useCallback} from 'react';

import {loadMetadata, selectMetadata} from 'entities/metadata';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';

/**
 * Интерфейс для параметров хука useLoadPublishFormMetadata
 * @interface
 * @property {boolean} isPublishListActionType - Флаг, указывающий, что это action типа PUBLISH_LIST
 * @property {string} [modalEntityName] - Опциональное имя сущности модального окна
 */
interface IUseLoadPublishFormMetadataArgs {
    isPublishListActionType: boolean;
    modalEntityName?: string;
}

/**
 * Хук для загрузки метаданных формы публикации
 *
 * @param {IUseLoadPublishFormMetadataArgs} props - Параметры хука
 * @returns {Object} Возвращает объект с метаданными формы публикации и функцией для их загрузки
 * @returns {any} publishFormMetadata - Метаданные формы публикации
 * @returns {Function} loadPublishFormMetadata - Функция для загрузки метаданных формы публикации
 */
export const useLoadPublishFormMetadata = ({
    isPublishListActionType,
    modalEntityName,
}: IUseLoadPublishFormMetadataArgs) => {
    const dispatch = useAppDispatch();

    const publishFormMetadata = useAppSelector(
        selectMetadata(modalEntityName ?? '', EEntityType.FORM),
    );

    const loadPublishFormMetadata = useCallback(() => {
        if (!isPublishListActionType || !modalEntityName || publishFormMetadata) {
            return;
        }

        dispatch(loadMetadata(modalEntityName, EEntityType.FORM));
    }, [modalEntityName, publishFormMetadata, dispatch, isPublishListActionType]);

    return {
        publishFormMetadata,
        loadPublishFormMetadata,
    };
};
